import { match } from 'ts-pattern';

import {
  SurveyCreationApiActions,
  SurveyCreationNavbarActions,
} from '../survey-creation-audience.actions';
import { RecalculationTrigger } from './recalculation-action-trigger.types';

// True whenever Score/Feasibility should show as pending: either it is
// actually about to recalculate, or it can't right now because manual
// processing is blocking it — and will stay pending until Save or
// toggling manual processing back off clears it.
export function shouldMarkAsPending(action: RecalculationTrigger): boolean {
  return match(action)
    .with(
      { type: SurveyCreationNavbarActions.toggleManualProcessing.type },
      (toggled) => !toggled.enabled,
    )
    .otherwise(() => true);
}

// Defines which actions should trigger a recalculation of Score and Feasibility.
export function qualifiesForRecalculation(
  action: RecalculationTrigger,
  enableManualProcessing: boolean,
): boolean {
  return match(action)
    .with(
      { type: SurveyCreationNavbarActions.toggleManualProcessing.type },
      (toggled) => !toggled.enabled,
    )
    .with(
      { type: SurveyCreationApiActions.loadSurveyForEditSuccess.type },
      { type: SurveyCreationApiActions.saveSurveySuccess.type },
      { type: SurveyCreationNavbarActions.recalculateFeasibility.type },
      () => true,
    )
    .otherwise(() => !enableManualProcessing);
}
